export const globalIframeClickHandler = () => {
    if (isIframe() && 'iframeTypeNum' in window && Array.isArray(window.top.window.handleIframeClicks)) {
        addEventListener('click', (event) => {
            if (event.target instanceof HTMLAnchorElement) {
                if (!event.target.href || event.target.href.length === 0) {
                    return
                }

                const destination = new URL(event.target.href)

                if (destination.origin !== window.location.origin) {
                    window.top.postMessage({type: "iframe-click-external-url", url: destination.href})
                    event.preventDefault()
                    return
                }

                if (destination.protocol.startsWith("http")/* && !destination.searchParams.has("type")*/) {
                    // destination.searchParams.append("type", window.iframeTypeNum) // This is done in embed view
                    event.preventDefault()
                    // window.location.href = destination.href
                    window.top.postMessage({type: "iframe-click-internal-url", url: destination.href})
                }
            }
        })
    }
}

export const isIframe = () => {
    try {
        return window.top !== window.self;
    } catch {
        return true;
    }
}
